import { Grid } from "@mui/material";
import { Formik, Form } from "formik";
import InputField from "../elements/InputField";
import CustomButton from "../elements/CustomButton";
import Modal from "../elements/Modal";

const CategoryModal = ({ open, handleClose, onAddCategory, setFieldValue }) => {
  return (
    <Modal
      open={open}
      modalTitle="Add New Category"
      handleClose={handleClose}
      width="sm"
    >
      <Formik
        initialValues={{ name: "" }}
        onSubmit={(catValues) => {
          onAddCategory({ name: catValues.name });
          setFieldValue("category", catValues.name);
          handleClose();
        }}
      >
        {({
          handleChange: catHandleChange,
          handleBlur: catHandleBlur,
          handleSubmit: catHandleSubmit,
          values: catValues,
        }) => (
          <Form noValidate onSubmit={catHandleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <InputField
                  fullWidth
                  label="Category Name"
                  id="name"
                  type="text"
                  value={catValues.name}
                  name="name"
                  placeholder="Category Name"
                  onBlur={catHandleBlur}
                  onChange={catHandleChange}
                  required
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      fontSize: "1rem",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomButton />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CategoryModal;